export default __webpack_public_path__ + "static/media/ally_background_s1.e2508522.jpg";